module.exports = __webpack_public_path__ + "img/img56.678d70d7.svg";